import { normalizeSearchFiltersPayload } from 'utils/filters';

import { analyticsInstance } from '../base';

import { normalizeFilterData } from './normalizers';
import {
  FILTER_DATA_AXIOS_INSTANCES,
  FILTER_DATA_INSTANCES,
  IFilterData,
  IRequestFilterProps,
} from './types';

const filtersApi = {
  async getFilterData({
    field,
    instance = FILTER_DATA_INSTANCES.CORE,
    pageFilters,
    prefix,
  }: IRequestFilterProps): Promise<IFilterData> {
    const normalizedFilter = normalizeSearchFiltersPayload(pageFilters);

    const selectedAxiosInstance = FILTER_DATA_AXIOS_INSTANCES[instance];

    const response = await selectedAxiosInstance.get(`${prefix}/field/${field}/values`, {
      params: normalizedFilter,
    });

    return normalizeFilterData(response.data);
  },

  async getAnalyticFilterData({
    field,
    pageFilters,
    prefix,
  }: IRequestFilterProps): Promise<IFilterData> {
    const normalizedFilter = normalizeSearchFiltersPayload(pageFilters);

    const response = await analyticsInstance.get(`${prefix}/field/${field}/values`, {
      params: normalizedFilter,
    });

    return normalizeFilterData(response.data);
  },
};

export default filtersApi;
